import * as React from 'react'
import { api } from '../lib/api'
import Card from '@mui/joy/Card'
import Button from '@mui/joy/Button'
import Input from '@mui/joy/Input'
export function Login() {
  const [email, setEmail] = React.useState('candidate@example.com')
  const [password, setPassword] = React.useState('password123')
  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    const r = await api('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    })
    localStorage.setItem('access', r.tokens.access)
    localStorage.setItem('refresh', r.tokens.refresh)
    localStorage.setItem('user', JSON.stringify(r.user))
    location.assign('/')
  }
  return (
    <div className="max-w-sm mx-auto p-6">
      <Card className="p-6 space-y-3" variant="outlined">
        <h2 className="text-xl font-semibold">Login</h2>
        <Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email" />
        <Input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="password"
        />
        <Button className="w-full" onClick={submit}>
          Login
        </Button>
      </Card>
    </div>
  )
}
export function Signup() {
  const [email, setEmail] = React.useState('new@example.com')
  const [password, setPassword] = React.useState('password123')
  const [name, setName] = React.useState('New User')
  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    const r = await api('/auth/signup', {
      method: 'POST',
      body: JSON.stringify({ email, password, name }),
    })
    localStorage.setItem('access', r.tokens.access)
    localStorage.setItem('refresh', r.tokens.refresh)
    localStorage.setItem('user', JSON.stringify(r.user))
    location.assign('/')
  }
  return (
    <div className="max-w-sm mx-auto p-6">
      <Card className="p-6 space-y-3" variant="outlined">
        <h2 className="text-xl font-semibold">Create account</h2>
        <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="name" />
        <Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email" />
        <Input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="password"
        />
        <Button className="w-full" onClick={submit}>
          Sign up
        </Button>
      </Card>
    </div>
  )
}
